import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../shared/base-service/base-api.service';
import { Jurisdiction } from '../vehicle/models/jurisdiction.model';

@Injectable()
export class CustomerLookupService extends BaseApiService {
    public getData(customerType: string): Observable<any> {
        return this.get('Customer/GetLookups/' + customerType);
    }

    public getCharacteristics(): Observable<any> {
        return this.get('Customer/GetCharacteristicLookups');
    }

    public getJurisdictions(): Observable<{ result: Jurisdiction[] }> {
        return this.get('Customer/Jurisdictions');
    }
}
